import {Actions, createEffect, ofType, ROOT_EFFECTS_INIT} from '@ngrx/effects';
import {catchError, EMPTY, switchMap} from 'rxjs';
import {Injectable} from '@angular/core';
import {BusinessPlanService} from "@modules/account-settings/pages/business-profile/services/business-plan.service";

@Injectable({
  providedIn: 'root'
})
export class BusinessPlanInitializerEffects {
  initBusinessPlan$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ROOT_EFFECTS_INIT),
      switchMap(() => this.businessPlanService.ensureLoaded$()),
      catchError(e => {
        console.error(e);

        return EMPTY;
      }),
    )
  }, {dispatch: false});

  constructor(
    private actions$: Actions,
    protected readonly businessPlanService: BusinessPlanService
  ) {
  }
}
